import { registerMutation, registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { deletePreferredCurrency, fetchPreferredCurrency, setPreferredCurrency } from './multiCurrencyApi';
import { fetchForecastCategoryConditionalPropertyRules } from './conditionalPropertiesApi';
import { fetchObjects } from './crmSearchApi';
import { fetchSpecificPipeline } from './pipelinesApi';
import { fetchValidForecastingOwners } from './ownersApi';
const GET_FORECAST_COLUMNS_FIELD = 'forecastColumns';
export const GET_FORECAST_COLUMNS = registerQuery({
  fieldName: GET_FORECAST_COLUMNS_FIELD,
  args: ['pipelineId'],
  fetcher(data) {
    //pipelineId is hs-forecast-columns for Forecast stage and would be a pipelineid for deal stage.
    return http.get(`forecasting/v1/forecast-columns/${data.pipelineId}`);
  }
});
export const GET_PREFERRED_CURRENCY = registerQuery({
  fieldName: 'preferredCurrency',
  fetcher: fetchPreferredCurrency
});
export const UPDATE_PREFERRED_CURRENCY = registerMutation({
  fieldName: 'preferredCurrency',
  fetcher: setPreferredCurrency
});
export const DELETE_PREFERRED_CURRENCY = registerMutation({
  fieldName: 'preferredCurrency',
  fetcher: deletePreferredCurrency
});
export const GET_LATEST_FORECAST_AI_OBJECT_FIELD = 'latestForecastAIObject';
export const GET_LATEST_FORECAST_AI_OBJECT = registerQuery({
  fieldName: GET_LATEST_FORECAST_AI_OBJECT_FIELD,
  fetcher() {
    return fetchObjects({
      objectTypeId: '0-149',
      count: 1,
      sorts: [{
        property: 'hs_createdate',
        order: 'DESC'
      }]
    });
  }
});
export const GET_FORECAST_CATEGORY_CONDITIONAL_PROPERTY_RULES_FIELD = 'forecastCategoryConditionalPropertyRules';
export const GET_FORECAST_CATEGORY_CONDITIONAL_PROPERTY_RULES = registerQuery({
  fieldName: GET_FORECAST_CATEGORY_CONDITIONAL_PROPERTY_RULES_FIELD,
  fetcher() {
    return fetchForecastCategoryConditionalPropertyRules();
  }
});
export const GET_DEAL_PIPELINE_FIELD = 'dealPipeline';
export const GET_DEAL_PIPELINE = registerQuery({
  fieldName: GET_DEAL_PIPELINE_FIELD,
  args: ['pipelineId'],
  fetcher: ({
    pipelineId
  }) => fetchSpecificPipeline(pipelineId)
});
export const GET_VALID_FORECASTING_OWNERS_FIELD = 'validForecastingOwners';
export const GET_VALID_FORECASTING_OWNERS = registerQuery({
  fieldName: GET_VALID_FORECASTING_OWNERS_FIELD,
  fetcher: ({
    month
  }) => fetchValidForecastingOwners(month)
});